import { getDisplayTextLabelText } from '../../../utils/display-text-utils';
import { logger } from '../../../utils/logger';
import { NotificationType } from '../types/notification-type';
import { addNotificationByType } from './add-notification-by-type';
export const addErrorNotification = (notificationDetails, error, internalActions) => {
    const { messages } = notificationDetails;
    const errorText = messages.map(getDisplayTextLabelText).join('. ');
    logger.error(errorText, error);
    addNotificationByType(notificationDetails, NotificationType.Error, internalActions);
};
